import { type FieldContentsData } from 'javascripts/shared-types';
import Field, { type Flavor } from '../../Field';

export class TeamLocation extends Field {
  static get availableForFlavors(): readonly Flavor[] {
    return ['develop', 'teamwork'];
  }

  static availableForModel(modelClass, recordLayout) {
    return super.availableForModel(modelClass, recordLayout);
  }

  static attributesForModel() {
    return ['teamLocation'];
  }

  get title() {
    return 'Location';
  }

  exampleContents(): FieldContentsData {
    return { text: 'Prioritized backlog' };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.teamLocation) {
      return { text: record.teamLocation };
    }

    return {};
  }
}
